import React from 'react'
import styles from './styles.module.scss'
import PropTypes from 'prop-types'

function IconButtonPure({ renderIcon, className, onClick, ...rest }) {
  return (
    <button className={`${styles.iconButton} ${className}`} onClick={onClick} {...rest}>
      {renderIcon && renderIcon()}
    </button>
  )
}

IconButtonPure.propTypes = {
  renderIcon: PropTypes.func.isRequired,
  onClick: PropTypes.func
}

export default IconButtonPure
